"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectStorage = exports.selectStorageInitialized = void 0;
const slice_1 = require("./slice");
const selectStorageInitialized = (state) => state.storageProvider.storageInitialized || slice_1.initialState.storageInitialized;
exports.selectStorageInitialized = selectStorageInitialized;
const selectStorage = (state) => state.storageProvider.storage || slice_1.initialState.storage;
exports.selectStorage = selectStorage;
//# sourceMappingURL=selectors.js.map